import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const decemberMap: Array<IPixelMapDay> = [
];

export default decemberMap;
